import React from 'react';
import { multiTariffsMobileTabsVariant } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { DefaultTabs } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsTabsMobile/Default/DefaultTabs';
import { ScrollableTabs } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsTabsMobile/Scrollable/ScrollableTabs';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface MultiTariffsTabsMobileProps {
    tabOptions: {
        value: ETabsName;
        text: string;
    }[];
    activeTariffTab?: ETabsName;
    onChangeTab: (value: ETabsName) => void;
}

export function MultiTariffsTabsMobile({ tabOptions, activeTariffTab, onChangeTab }: MultiTariffsTabsMobileProps) {
    if (multiTariffsMobileTabsVariant === 'scroll') {
        return <ScrollableTabs tabOptions={tabOptions} activeTariffTab={activeTariffTab} onChangeTab={onChangeTab} />;
    }
    return <DefaultTabs tabOptions={tabOptions} activeTariffTab={activeTariffTab} onChangeTab={onChangeTab} />;
}
